import { setSignupTracking } from '@cencosud-cencommerce/paris-login';

import { BrazeSignupTrackingAdapter } from './signupTracking.adapter';

let injected = false;

export function injectSignupTrackingAdapter() {
  if (injected) return;

  if (!window?.braze) return;

  setSignupTracking(new BrazeSignupTrackingAdapter());
  injected = true;

  console.info('[Braze] SignupTrackingAdapter injected');
}
